import { useState, useCallback } from 'preact/hooks'
import icons from '../../../icons'
import style from './style.module.css'

export function Help() {
    const [isOpen, setIsOpen] = useState(false)

    const toggleHelpText = useCallback(() => {
        setIsOpen(!isOpen)
    }, [isOpen])

    const classes = [style.help]
    if (isOpen) {
        classes.push(style.open)
    }

    return (
        <div class={classes.join(' ')}>
            <p class={style.toggle} onClick={toggleHelpText}>
                {isOpen ? (
                    <>
                        Piilota ohjeet<span class={style.arrowHide}>&#9650;</span>
                    </>
                ) : (
                    <>
                        Näytä ohjeet<span class={style.arrowShow}>&#9660;</span>
                    </>
                )}
            </p>
            <section class={style.helpText}>
                <ul>
                    <li>
                        <p class={style.icon}>{icons.TMAX}</p>
                        <p class={style.text}>Ylin</p>
                        Kuukauden keskimääräinen ylin lämpötila
                    </li>
                    <li>
                        <p class={style.icon}>{icons.TMIN}</p>
                        <p class={style.text}>Alin</p>
                        Kuukauden keskimääräinen alin lämpötila
                    </li>
                    <li>
                        <p class={style.icon}>{icons.SST}</p>
                        <p class={style.text}>Merivesi</p>
                        Meriveden keskimäääräinen lämpötila
                    </li>
                    <li>
                        <p class={style.icon}>{icons.SUNPCT}</p>
                        <p class={style.text}>Auringonpaiste</p>
                        Aurinkoisen ajan keskimääräinen osuus päivisin
                    </li>
                    <li>
                        <p class={style.icon}>{icons.PRDAYS}</p>
                        <p class={style.text}>Sadepäiviä</p>
                        Kuukauden keskimääräinen sadepäivien määrä (&ge; 0,1 mm/vrk)
                    </li>
                    <li>
                        <p class={style.icon}>{icons.PR}</p>
                        <p class={style.text}>Sademäärä</p>
                        Kuukauden keskimääräinen sademäärä
                    </li>
                </ul>

                <p>
                    Keskiarvot perustuvat vuosien 1991&ndash;2020 ilmastotietoihin. Ilmastotiedot päivitetään 10 vuoden
                    välein.
                </p>
            </section>
        </div>
    )
}
